import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DebtsDtoKeysEnum } from '@zaoblako/shared/modules/debts/enums/debts-dto-keys.enum';

import * as yup from 'yup';

/** Debt collection task event type response body - DTO signature */
export interface DebtCollectionTaskEventTypeFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Event type creation date and time */
  created: Date;
  /** Event type last update date and time */
  updated: Date;
  /** Event type soft deletion date and time */
  deleted?: Date;
  /** Event type creator */
  createdBy?: UserFindInterface;

  // Data columns
  /** Event type display name */
  name: string;
  /** Event type additional description */
  description?: string;
  /** Event type color */
  color?: string;
  /** The default event type. Each tenant can only have one of this event type. */
  isDefault?: boolean;
}

/** Debt collection task event type response body - DTO schema */
export const DebtCollectionTaskEventTypeFindDto = SerdeDtoClass.create<DebtCollectionTaskEventTypeFindInterface>(DebtsDtoKeysEnum.DEBT_COLLECTION_TASK_EVENT_TYPE_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Дата создания',
    serializer: yup.date(),
  },
  updated: {
    label: 'Дата последнего изменения',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Дата удаления',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: yup.string(),
  },
  isDefault: {
    optional: true,
    label: 'По-умолчанию',
    serializer: yup.boolean(),
  },
});
